import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Paper, Typography, Container, Button, Divider,
} from "@mui/material";

import { i18n } from '../../../translate/i18n';

import {
  FormStyled,
  DivFormTitle,
  FormNewMaintenance,
  InputView, 

} from "./styles";
import Spinner from "../../../components/Spinner/index";
import * as actions from "../../../store/actions";
import TimelineItem from "../TimelineItem";
import NewMaintenancePostInput from '../../../components/NewMaintenancePostInput/NewMaintenancePostInput';

const styles = {
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: "relative"
  },
  iconButton: {
    marginRight: 5,
  },
  timelineTitle: {
    fontWeight: 700,
  },
  timelineContainer: {
    borderRadius: 10,
    backgroundColor: '#fff',
    padding: 10,
  },
  sendButton: {
    position: 'absolute',
    bottom: 15,
    right: 20,
    backgroundColor: '#87d299',
    color: '#000',
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 3,
  },
};

const TimelineMaintenances = (props) => {
  const dispatch = useDispatch();
  const loadingMaintenances = useSelector(state => state.maintenances.timelineMaintenancesLoading);
    
  const maintenance = useSelector(state => state.maintenances.maintenance);
  const [showMessageInput, setShowMessageInput] = useState(false);
  
  const handleShowMessageInput = () => {
    setShowMessageInput(true);
  };

  const handleHideMessageInput = () => {
    setShowMessageInput(false);
  };

  return (
    <>
      <Container maxWidth="sm" style={styles.container}>
        <FormNewMaintenance onClick={handleShowMessageInput}>
          <InputView placeholder={i18n.t('inputViewTimeActions.placeholder')} onChange={handleShowMessageInput} />
          <Button variant="contained" color="primary" style={styles.sendButton}>
            {i18n.t('buttonTimeActions.text')}
          </Button>
        </FormNewMaintenance>
        {loadingMaintenances && <Spinner overlay />}
        <DivFormTitle style={{opacity: loadingMaintenances ? "0.3" : "1"}}>
          <Typography variant="h6" style={styles.timelineTitle}>{i18n.t('typographyTimeActions.timelineTitle')}</Typography>
        </DivFormTitle>
        <div style={styles.timelineContainer}>
          <FormStyled style={{ opacity: loadingMaintenances ? "0.3" : "1" }}>      
            <div style={{ marginTop: "10px" }}>
              <TimelineItem timeline={maintenance.timeline} />
            </div>
          </FormStyled>
        </div>
      </Container>
      {showMessageInput && <NewMaintenancePostInput maintenance={maintenance} closeModal={handleHideMessageInput} />}
    </>
  );
};

export default TimelineMaintenances;
